import request from '@/utils/request'
import { v2Host } from '@/config/host'

/**
 * createTag
 * @param {{name: string, type_id: number}} data
 */
export function createTag(data) {
  return request({
    url: `${v2Host}/tag/create`,
    method: 'post',
    data: data
  })
}
